import React from 'react'
import moment from 'moment'
import { arrayOf, string, number, array, bool } from 'prop-types'
import classnames from 'classnames'

import Type from '@/component/Primitive/Type'
import ResponsiveSpacer from '@/component/Primitive/ResponsiveSpacer'

import ListItem from './component/ListItem'

import styles from './KeyDetails.module.scss'
import ListItemV2 from './component/ListItemV2'

const KeyDetails = ({
  genre,
  duration,
  releaseYear,
  releaseDate,
  rejectedDate,
  className,
  sourceUri,
  directors,
  cast,
  layoutV2
}) => {
  const durationInMinutes = (duration / 60).toFixed(0)

  if (layoutV2) {
    return (
      <div className={classnames(styles.KeyDetailsV2, className)}>
        <div className={styles.ListV2}>
          {directors && directors.length > 0 && (
            <ListItemV2 title="Director(s)" value={directors.join(', ')} />
          )}
          {releaseYear && (
            <ListItemV2 title="Production year" value={releaseYear} />
          )}
          {releaseDate && (
            <ListItemV2
              title="Release date"
              value={moment(releaseDate).format('DD/MM/YYYY')}
            />
          )}
          {rejectedDate && (
            <ListItemV2
              title="Date"
              value={moment(rejectedDate).format('DD/MM/YYYY')}
            />
          )}
          {genre && genre.length > 0 && (
            <ListItemV2 title="Genre(s)" value={genre.join(', ')} />
          )}
          {duration && (
            <ListItemV2
              title="Approx. running minutes"
              value={`${durationInMinutes}m`}
            />
          )}
          {cast && cast.length > 0 && (
            <ListItemV2 title="Cast" value={cast.join(', ')} />
          )}
        </div>
        <ResponsiveSpacer small />
        {sourceUri && sourceUri.includes('imdb') && (
          <a
            className={styles.PosterDetails}
            href={sourceUri}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>Posters powered by IMDb</span>
          </a>
        )}
      </div>
    )
  }
  return (
    <div className={classnames(styles.KeyDetails, className)}>
      <ul className={styles.List}>
        {directors && directors.length > 0 && (
          <ListItem title="Director(s)" value={directors.join(', ')} />
        )}
        {releaseYear && (
          <ListItem title="Production Year" value={releaseYear} />
        )}
        {releaseDate && (
          <ListItem
            title="Release date"
            value={moment(releaseDate).format('DD/MM/YYYY')}
          />
        )}
        {rejectedDate && (
          <ListItem
            title="Date"
            value={moment(rejectedDate).format('DD/MM/YYYY')}
          />
        )}
        {genre && genre.length > 0 && (
          <ListItem title="Genre(s)" value={genre.join(', ')} />
        )}
        {duration && (
          <ListItem
            title="Approx. running minutes"
            value={`${durationInMinutes}m`}
          />
        )}
        {cast && cast.length > 0 && (
          <ListItem title="Cast" value={cast.join(', ')} />
        )}
      </ul>
      <ResponsiveSpacer small />
      {sourceUri && sourceUri.includes('imdb') && (
        <a href={sourceUri} target="_blank" rel="noopener noreferrer">
          <Type size="base">Posters powered by IMDb</Type>
        </a>
      )}
    </div>
  )
}

KeyDetails.propTypes = {
  genre: arrayOf(string),
  duration: number,
  className: string,
  sourceUri: string,
  releaseDate: string,
  releaseYear: string,
  rejectedDate: string,
  directors: array,
  cast: array,
  layoutV2: bool
}

export default KeyDetails
